module.exports = __webpack_public_path__ + "img/specializationZongdefen.583b20a3.jpg";